'use client';

import { Text } from '@stone-payments/jade';
import { useIntl } from 'react-intl';
import { MiniLogoStone } from '../header/miniLogoStone';

export function BottomDetails() {
  const { formatMessage } = useIntl();

  return (
    <div className="flex flex-col gap-2 w-full justify-center center items-center">
      <div className="flex items-center gap-1">
        <Text>{formatMessage({ id: 'bottomDetails.processedBy' })}</Text>
        <MiniLogoStone />
      </div>
    </div>
  );
}
